import React from 'react'
import { DashboardLayout } from '../layouts'
import { AddAdminForm } from '../containers'

function AddAdmin() {
  return (
    <DashboardLayout>
        <div>

            <AddAdminForm/>

        </div>

    </DashboardLayout>
  )
}

export default AddAdmin